import { createContext } from 'react';

export const ProjectBatchesContext = createContext<{ _id: string; name: string }[]>([]);
